import React from 'react'
import ScrollAnimation from "react-animate-on-scroll";
import Marquee from "react-fast-marquee";

const Partners = () => {

   const patners = [
    {
      id: 1,
      img: "./assets/lagos.svg",
    },
    {
      id: 2,
      img: "./assets/wema.svg",
    },
    {
      id: 3,
      img: "./assets/prov.svg",
    },
    {
      id: 4,
      img: "./assets/vfd.svg",
    },
    {
      id: 5,
      img: "./assets/orange.svg",
    },
    {
      id: 6,
      img: "./assets/hngr.svg",
    },
    {
      id: 7,
      img: "./assets/aws.svg",
    },
    {
      id: 8,
      img: "./assets/safa.svg",
    },
    {
      id: 9,
      img: "./assets/hub.svg",
    },
    {
      id: 10,
      img: "./assets/wipo.svg",
    },
    {
      id: 11,
      img: "./assets/paystack.svg",
    },
    {
      id: 12,
      img: "./assets/openai.svg",
    },
    {
      id: 13,
      img: "./assets/nitda.svg",
    },
    {
      id: 14,
      img: "./assets/lse.svg",
    },
    {
      id: 15,
      img: "./assets/azure.svg",
    },
  ];
  return (
  <div className="p-5 md:p-[36px] flex flex-col gap-4 md:gap-5">
         <p className="font-semibold text-lg md:text-xl lg:text-[24px] text-center mb-4 md:mb-6">
           Our Recent Clients & Partners
         </p>
         {/* <div className="grid grid-cols-4 lg:grid-cols-8 gap-2  md:gap-4"> */}
 
         <Marquee>
           {patners.map((datum, index) => (
             <div
               key={index}
               className="w-full flex items-center justify-center mr-2 md:mr-3"
             >
               <img
                 src={datum.img}
                 alt="patrners-logo"
                 className="h-[30px] lg:h-[34px] object-contain"
               />
             </div>
           ))}
         </Marquee>
 
         <p className="text-xs md:text-base lg:text-base mt-5  text-center text-gray-400">
           Join 4,000+ companies already growing
         </p>
       </div>
 
)
}

export default Partners